import { Theme, useTheme } from '@pmi.web/react-theme';
import { PropsWithChildren, useEffect } from 'react';

import PaymentStore from '@/services/payments/PaymentStore';

import { FaviconLinkMissingError } from './exceptions/FaviconLinkMissingError';

export function ThemedPage({ children }: PropsWithChildren) {
  const { setTheme, theme } = useTheme();

  const updateHtmlThemeFaviconLink = (newTheme: Theme) => {
    // Favicons are named with the same values as the AppThemes
    const faviconPath = `/${newTheme}_favicon.ico`;
    const htmlFaviconLink = Array.from(
      document.getElementsByTagName('link'),
    ).find((linkElement) => linkElement.getAttribute('rel') === 'icon');

    if (!htmlFaviconLink) {
      throw new FaviconLinkMissingError(faviconPath);
    }

    htmlFaviconLink.setAttribute('href', faviconPath);
  };

  useEffect(() => {
    setTheme(PaymentStore.theme);
  }, []);

  useEffect(() => {
    if (theme) {
      updateHtmlThemeFaviconLink(theme);
    }
  }, [theme]);

  return <>{children}</>;
}
